import clients from './clients'
import users from './users'
import mixers from './mixers'
import groups from './groups'
import perm from './perm'

export default {
  clients,
  users,
  mixers,
  groups,
  perm
}
